import React from 'react';
import {Box, FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import "../../styles/ArrangeDurationSelectorStyle.scss"
import {HILIGHT_COLOR} from "../../constants/constants";

interface AlfyRadioOption {
    value: string,
    label: string,
}

interface AlfyRadioButtonsGroupProps {
    selectedValue: string | null;
    setSelectedValue: React.Dispatch<React.SetStateAction<string | null>>;
    options: AlfyRadioOption[]
}

export const AlfyRadioButtonsGroup: React.FC<AlfyRadioButtonsGroupProps> = ({ selectedValue, setSelectedValue, options }) => {

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        setSelectedValue(event.target.value)
    }

    return (
        <>
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="duration-buttons-group"
                    value={selectedValue}
                    onChange={handleChange}
                    row
                >
                    {options.map((option, index) => (
                        <CustomFormControlLabel
                            key={option.value}
                            option={option}
                            selectedValue={selectedValue}
                            isLast={index === options.length - 1}
                        />
                    ))}
                </RadioGroup>
                <br/>
            </FormControl>
        </>
    );
}

interface CustomFormControlProps {
    option: AlfyRadioOption,
    selectedValue: string | null,
    isLast: boolean,
}

const CustomFormControlLabel: React.FC<CustomFormControlProps> = ({ option, selectedValue, isLast }) => {
    let selected = selectedValue === option.value;

    return (
        <Box sx={{
            marginRight: isLast ? '0px' : '6px',
            borderRadius: '100px',
            backgroundColor: selected ? HILIGHT_COLOR : '#F5F5F5',
            padding: '8px 12px',
            color: selected ? 'white' : '#616161',
        }}>
            <FormControlLabel
                value={option.value}
                control={<Radio sx={{display: 'none'}} />}
                sx={{marginLeft: '0px', marginRight: '0px', lineHeight: '16.71px'}}
                label={option.label}
            />
        </Box>
    )
}